import { useEffect, useState } from "react";
import { hideLoader, showLoader } from "redux/action/loaderAction";
import { useParams } from "react-router-dom";
import { useTypedDispatch, useTypedSelector } from "App/Store";
import { reset } from "redux-form";
import { getBracketSettingsDetails } from "redux/action/bracketSettingsDetailsAction";
import { getParticipantInfoList } from "redux/action/participantInfoAction";
import CombinedBracket from "components/CombinedBracket";

interface UrlParams {
  tournamentId: string;
}

export default function AddBracketSettings() {
  const dispatch = useTypedDispatch();
  const { tournamentId } = useParams<UrlParams>();

  const selector = (state: any) =>
    state.form?.["combined-bracket-form"]?.values || {};
  const selectedBracketStyle = useTypedSelector(
    (state) => selector(state)?.bracketStyle
  );
  const selectedEligibleParticipants = useTypedSelector(
    (state) => selector(state)?.eligibleParticipants
  );
  const selectedThirdMatch = useTypedSelector(
    (state) => selector(state)?.thirdPlaceMatch
  );
  const tournamentTeams = useTypedSelector(
    (state) => state.participantInfo?.tournamentTeams
  );
  const bracketRounds = useTypedSelector(
    (state) => state.bracketSetting?.bracketRounds
  );

  const [filteredParticipants, setFilteredParticipants] = useState(
    tournamentTeams || []
  );
  const [isProccedSeed, setIsProccedSeed] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(reset("add-bracket"));
      dispatch(reset("bracket-seed-form"));
    };
  }, [dispatch]);

  useEffect(() => {
    if (!tournamentTeams) return;
    let updated = [...tournamentTeams];
    if (selectedEligibleParticipants === "checkedIn") {
      updated = updated.filter((team) => team.checkedIn);
    }
    setFilteredParticipants(updated);
  }, [selectedEligibleParticipants, tournamentTeams]);

  useEffect(() => {
    if (!selectedBracketStyle && selectedBracketStyle !== "Round Robin") return;
    const params = {
      bracketType: selectedBracketStyle,
      thirdPlaceMatch: selectedThirdMatch ? "y" : "n",
    };
    dispatch(getBracketSettingsDetails(tournamentId, params));
  }, [dispatch, selectedBracketStyle, selectedThirdMatch, tournamentId]);

  useEffect(() => {
    dispatch(showLoader());
    dispatch(getParticipantInfoList(tournamentId));
    dispatch(hideLoader());
  }, [dispatch, tournamentId]);

  return (
    <div>
      <CombinedBracket
        bracketRounds={bracketRounds}
        participantCount={filteredParticipants?.length || 0}
        filteredParticipants={filteredParticipants}
        isEditMode={isProccedSeed}
      />
    </div>
  );
}
